import React, { useEffect } from 'react';
import { logout } from './api/User';
import { useNavigate } from "react-router-dom";

function Logout() {
    const navigate = useNavigate();

    useEffect(() => {
        handleConfirmLogout();
    }, []); 
    const handleConfirmLogout = () => {
        sessionStorage.clear();
        logout();
        navigate("/");
    };

    return (
        <div>Logging out...</div>
    );
}

export default Logout;
